import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { isBrowser } from 'angular2-universal';

import { ContentService } from '../shared/content.service';
import { Content } from '../shared/content';
import { UtilsService } from '../shared/utils.service';
import { ConfigService } from '../shared/config.service';
import { IntlService } from '../shared/intl.service';
import { MetaService } from '../shared/meta.service';
 
@Component({
    template: require('./partials/content-page.html'),
    providers: [ContentService, MetaService]
}) 
export class ContentPageComponent extends Content {

    constructor(private pageConfig: ConfigService, private pageIntlService: IntlService, public utils: UtilsService, private pageMetaService: MetaService, private pageService: ContentService, private pageRoute: ActivatedRoute) {
        super(pageConfig, pageIntlService, pageMetaService, pageService, pageRoute);
        this.setType('page');
    }

    // Overrides super class init
    ngOnInit(){
        this.setCurrentLanguage();
        this.setContentAsync();
        this.contentAsync.subscribe(
            (page: Object) => {
                if(page!=null) {
                    this.content = page;
                    this.ready();
                    this.setMeta();
                } else
                    console.error('Content not set');
            }
        );
    }

    ngAfterContentChecked(){
        super.ngAfterContentChecked();
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-page.component.ts